import { JobProgressDashComponent } from './job-progress-dash/job-progress-dash.component';
import { KpiSetupDialogComponent } from './kpi-setup-dialog/kpi-setup-dialog.component';
import { KpiTargetComponent } from './kpi-target/kpi-target.component';
import { ResponsibleCompanyComponent } from './responsible-company/responsible-company.component';
import { SecondMatchDialogComponent } from './second-match-dialog/second-match-dialog.component';

export const DASHBOARD_COMPONENTS = [KpiTargetComponent, JobProgressDashComponent, ResponsibleCompanyComponent, KpiSetupDialogComponent];
export const DASHBOARD_DIALOG_COMPONENTS = [KpiSetupDialogComponent, SecondMatchDialogComponent];
